import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 30, className = "", testid }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={{ opacity: 0, y: reduced ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  const reduced = useReducedMotion();
  return (
    <span className={`mask ${className}`}>
      <motion.span
        className="mask-inner"
        initial={reduced ? { y: 0, opacity: 1 } : { y: "112%" }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: reduced ? 0 : 0.95, delay: reduced ? 0 : delay, ease: [0.19, 1, 0.22, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}
